// Theme JavaScript

// Cart functionality
document.addEventListener('DOMContentLoaded', function() {
  
  // Sort collection products
  const sortSelect = document.getElementById('sort-by');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  // Product form variant selection
  const productForm = document.querySelector('.product-form');
  if (productForm) {
    const variantSelects = productForm.querySelectorAll('select[name^="options"]');
    
    if (variantSelects.length > 0) {
      variantSelects.forEach(select => {
        select.addEventListener('change', updateVariant);
      });
    }

    function updateVariant() {
      // Get selected options
      const selectedOptions = Array.from(variantSelects).map(select => select.value);
      
      // Note: This requires product.variants to be available in the page
      // Make sure to include product JSON in the product page template
      if (typeof product !== 'undefined' && product.variants) {
        const variant = product.variants.find(v => {
          return v.options.every((option, index) => option === selectedOptions[index]);
        });
        
        if (variant) {
          // Update hidden variant input
          const variantInput = document.querySelector('input[name="id"]');
          if (variantInput) {
            variantInput.value = variant.id;
          }
          
          // Update price
          const priceElement = document.querySelector('.product-page__price .price');
          if (priceElement && variant.price) {
            priceElement.textContent = formatMoney(variant.price);
          }
          
          // Update availability
          const submitButton = productForm.querySelector('button[type="submit"]');
          if (submitButton) {
            if (variant.available) {
              submitButton.disabled = false;
              submitButton.innerHTML = '<i class="fas fa-shopping-cart"></i> Ajouter au panier';
            } else {
              submitButton.disabled = true;
              submitButton.innerHTML = 'Épuisé';
            }
          }
        }
      }
    }
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  // Add to cart with AJAX
  const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');
  
  addToCartForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const formData = new FormData(this);
      const submitButton = this.querySelector('button[type="submit"]');
      const originalContent = submitButton.innerHTML;
      
      // Disable button during request
      submitButton.disabled = true;
      submitButton.innerHTML = 'Ajout en cours...';
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        // Update cart count
        updateCartCount();
        
        // Show success notification
        showNotification('Produit ajouté au panier !', 'success');
        
        // Re-enable button
        submitButton.disabled = false;
        submitButton.innerHTML = originalContent;
      })
      .catch(error => {
        showNotification('Erreur lors de l\'ajout au panier', 'error');
        
        // Re-enable button
        submitButton.disabled = false;
        submitButton.innerHTML = originalContent;
      });
    });
  });

  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCountElements = document.querySelectorAll('.cart-count');
        cartCountElements.forEach(element => {
          element.textContent = cart.item_count;
          if (cart.item_count > 0) {
            element.style.display = 'flex';
          }
        });
      })
      .catch(error => {});
  }

  // Show notification instead of alert
  function showNotification(message, type = 'info') {
    // Remove existing notifications
    const existingNotifications = document.querySelectorAll('.notification');
    existingNotifications.forEach(n => n.remove());
    
    const notification = document.createElement('div');
    notification.className = `notification notification-${type}`;
    notification.textContent = message;
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: ${type === 'success' ? '#2d5016' : '#c44'};
      color: white;
      padding: 1rem 2rem;
      border-radius: 50px;
      z-index: 9999;
      animation: slideIn 0.3s ease;
      box-shadow: 0 4px 15px rgba(0,0,0,0.3);
      font-weight: 600;
    `;
    document.body.appendChild(notification);
    
    setTimeout(() => {
      notification.style.animation = 'slideOut 0.3s ease';
      setTimeout(() => notification.remove(), 300);
    }, 3000);
  }

  // Initial cart count update
  updateCartCount();

  // Popup functionality
  const popup = document.getElementById('popup-overlay');
  if (popup) {
    const closeBtn = document.getElementById('popup-close');
    const delay = parseInt(popup.dataset.delay) || 2000;
    const cookieName = 'popup_shown';
    const cookieDays = parseInt(popup.dataset.cookieDays) || 1;

    // Vérifier si le popup a déjà été affiché
    function getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    }

    function setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      const expires = `expires=${date.toUTCString()}`;
      document.cookie = `${name}=${value};${expires};path=/`;
    }

    // Afficher le popup après le délai si pas déjà vu
    if (!getCookie(cookieName)) {
      setTimeout(function() {
        popup.classList.add('popup-visible');
      }, delay);
    }

    // Fermer le popup
    function closePopup() {
      popup.classList.remove('popup-visible');
      setCookie(cookieName, 'true', cookieDays);
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', closePopup);
    }
    
    popup.addEventListener('click', function(e) {
      if (e.target === popup) {
        closePopup();
      }
    });
  }

});
